// The single market test, so the US exception lives in one place rather than
// once per thing that varies by market. Case-insensitive on purpose: callers
// uppercase for the imperial-unit lookups in measurementConfig.ts, and a raw
// "us" must not fall through to the default meant for everywhere else.
export function isUS(countryCode: string | undefined): boolean {
  return countryCode?.toUpperCase() === "US";
}
